// removed by extract-text-webpack-plugin
module.exports = {"list":"_219JD-CCosEk2XHROsl2EX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/RecipientDetailedStatsList/RecipientDetailedStatsList.scss
// module id = 628
// module chunks = 1